/**
 * Display label + colour maps for tournament enums. Split out of tournaments.ts
 * to keep every file under 400 LOC. Colours are semantic values
 * (red = LIVE, green = open, cyan = ready, gold = completed, muted = ended).
 */

import {BracketType, TournamentStatus} from "./tournamentEnums";

export const BracketTypeLabels: Record<BracketType, string> = {
    [BracketType.SINGLE_ELIMINATION]: "Single Elimination",
    [BracketType.DOUBLE_ELIMINATION]: "Double Elimination",
    [BracketType.ROUND_ROBIN]: "Round Robin",
    [BracketType.SWISS]: "Swiss",
    [BracketType.GROUPS_KNOCKOUT]: "Groups + Knockout",
};

/** @deprecated Use BracketTypeLabels instead */
export const TournamentFormatLabels = BracketTypeLabels;

export const TournamentStatusLabels: Record<TournamentStatus, string> = {
    [TournamentStatus.DRAFT]: "Draft",
    [TournamentStatus.REGISTRATION]: "Registering",
    [TournamentStatus.READY]: "Ready to Start",
    [TournamentStatus.IN_PROGRESS]: "In Progress",
    [TournamentStatus.COMPLETED]: "Completed",
    [TournamentStatus.CANCELLED]: "Cancelled",
};

export const TournamentStatusColors: Record<TournamentStatus, string> = {
    [TournamentStatus.DRAFT]: "#6B6B72",
    [TournamentStatus.REGISTRATION]: "#22C55E",
    [TournamentStatus.READY]: "#00D4FF",
    [TournamentStatus.IN_PROGRESS]: "#F1161D",
    [TournamentStatus.COMPLETED]: "#FFD24A",
    [TournamentStatus.CANCELLED]: "#6B6B72",
};
